// extracted by mini-css-extract-plugin
export default {"container":"confirmOrder_container__wrs2w","content":"confirmOrder_content__eebBy","btnBox":"confirmOrder_btnBox__Bb68a"};